// extracted by mini-css-extract-plugin
module.exports = {"accordion":"modelTrims_accordion__7ghcV","tabs":"modelTrims_tabs__8rpwt"};